module.exports = __webpack_public_path__ + "static/img/12.b4be95a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/12.png
// module id = 7Bdq
// module chunks = 0